import React from "react";
import Select, { components } from "react-select";

import { EMPTY_STRING } from "../../../constants";
import { shopifyDropdownStyle } from "../../../assets/scss/style";

const ShopifySelectDropdown = ({
  options = [],
  handleChange,
  isBlack = false,
  placeholder = "Select...",
  selectedValue = EMPTY_STRING,
}) => {
  // Custom style function to control background color based on selectedValue
  const customStyles = {
    ...shopifyDropdownStyle,
    control: (provided, state) => {
      let backgroundColor = "transparent";
      let borderColor = provided.borderColor;
      if (selectedValue && selectedValue.value) {
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        borderColor = "green";
      } else {
        backgroundColor = "rgba(255, 0, 0, 0.1)";
        borderColor = "red";
      }
      // Merge shopifyDropdownStyle.control if it exists
      const baseControl =
        typeof shopifyDropdownStyle.control === "function"
          ? shopifyDropdownStyle.control(provided, state)
          : shopifyDropdownStyle.control || {};
      return {
        ...provided,
        ...baseControl,
        backgroundColor,
        borderColor,
        color: "black", // set default text color
        boxShadow: state.isFocused
          ? `0 0 0 1px ${borderColor}`
          : provided.boxShadow,
        "&:hover": {
          borderColor,
        },
      };
    },
    singleValue: (provided) => ({
      ...provided,
      color: isBlack ? "black" : "white", // set selected value text color
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: isBlack ? "black" : "white", // set dropdown icon color
      "&:hover": {
        color: isBlack ? "black" : "white",
      },
    }),
  };

  return (
    <Select
      name="store"
      id="store"
      options={options}
      value={selectedValue}
      isSearchable={false}
      placeholder={placeholder}
      styles={customStyles}
      onChange={handleChange}
    />
  );
};

export default ShopifySelectDropdown;
